









import { Component, Prop, Vue } from 'vue-property-decorator';
import { Warning } from '@/pages/profile/components';
import MentoringProgramsList from '../../programslist';
import { REQUEST_WARNING } from '@/pages/profile/modules';
import { IMentoringCurrentPrograms, Programs } from './types';

@Component({
  components: {
    Warning,
    MentoringProgramsList,
  },
})
export default class MentoringCurrentPrograms
  extends Vue
  implements IMentoringCurrentPrograms {
  @Prop({ type: Array, default: () => [] })
  readonly items!: Programs;

  warningText: string = REQUEST_WARNING;

  get currentItems(): Programs {
    // Здесь фильтруем по завершенным запросам
    return this.items.filter((item) => item.status !== '3');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/mentoring/views/currentprograms/MentoringCurrentPrograms.vue